<template>
  <tr>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-indigo-600 hover:underline">
        <button @click="toVehicleForm()">{{ vehicle.license_plate }}</button>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ vehicle.vin }}</div>
    </td>
    <td v-if="showInternalData" class="px-2 py-2 whitespace-nowrap">
      <div class="flex flex-col">
        <div class="text-sm text-gray-900">{{ vendorDisplay }}</div>
        <div class="pl-2 text-sm w-48 text-gray-500">{{ vehicle.vendor.partition.description }}</div>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ vehicle.make }}</div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ vehicle.model }}</div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ vehicle.color }}</div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">{{ vehicle.capacity }}</div>
    </td>
  </tr>
</template>

<script>

export default {
  components: {
  },
  props: {
    vehicle: Object,
    showInternalData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    toVehicleForm() {
      this.$router.push({
        name: 'VehicleForm',
        params: { id: String(this.vehicle.id) },
      })
    },
  },
  computed: {
    vendorDisplay() {
      if(this.vehicle.vendor.abbreviation == this.vehicle.vendor.name) {
        return this.vehicle.vendor.name
      } else {
        return `${this.vehicle.vendor.abbreviation} - ${this.vehicle.vendor.name}`
      }
    }
  },
}
</script>